import React from 'react'
import { change as changeFieldValue, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import adicionarDadosComprador from '../../actions/viagem/adicionarDadosComprador';
import ModalDadosComprador from './ModalDadosComprador';
import { paisesDDI } from '../../util/constantsUtil';

export const validate = (values) => {
  const errors = {};
  if (!values.nome) {
    errors.nome = 'Campo obrigatório'
  }
  if (!values.email) {
    errors.email = 'Campo obrigatório'
  }
  if (!values.cpf) {
    errors.cpf = 'Campo obrigatório'
  }
  if (!values.telefone) {
    errors.telefone = 'Campo obrigatório'
  }

  return errors
};

export class DadosComprador extends React.Component {
  constructor (props) {
    super(props);
    this.limparFormulario = this.limparFormulario.bind(this);
    this.state = {
      mensagem: { tipo: '', texto: '' },
      arquivo: null
    };
  }


  alterarAba (aba) {
    this.setState({ tabAtiva: aba })
  }

  ativarAba (aba) {
    if (aba === this.state.tabAtiva) {
      return 'nav-link active'
    }
    return 'nav-link'
  }

  limparMensagem () {
    this.setState({ mensagem: undefined })
  }

  limparFormulario () {
    this.props.reset('formReserva');
    this.limparMensagem();
  }

  getDDi(ddiComprador) {
    return paisesDDI.find(it => it.id === ddiComprador)
  }

  formatarDDi(comprador) {    
    const ddiComprador = this.getDDi(comprador)
    return `${ddiComprador.pais} ${ddiComprador.ddi}`
  }

  preencherValoresComprador (comprador) {
    this.props.changeFieldValue('formularioCadastrarDadosComprador', 'nome', comprador.nomeComprador);
    this.props.changeFieldValue('formularioCadastrarDadosComprador', 'cpf', comprador.cpfComprador);
    this.props.changeFieldValue('formularioCadastrarDadosComprador', 'telefone', comprador.telefoneComprador);    
    if (comprador.ddiComprador) {      
      const ddiComprador = this.getDDi(comprador.ddiComprador)
      this.props.changeFieldValue('formularioCadastrarDadosComprador', 'ddiComprador', { label: `${ddiComprador.pais} ${ddiComprador.ddi}`,  value: ddiComprador.id });
    } else {
      this.props.changeFieldValue('formularioCadastrarDadosComprador', 'ddiComprador', {label: 'Brasil +55', value: 32});
    }
  }

  render () {
    if (this.props.dadosPagamento) {
      return (
          <React.Fragment>
            <div className="container-fluid">
              <div className="row">
                <table className="table table-striped table-sm table-bordered text-center mt-2">
                  <thead>
                  <tr>
                    <td colSpan={4} className='text-center'>
                      <strong>Dados de Pagamento</strong>
                    </td>
                  </tr>
                  <tr>
                    <th scope="col">Nome</th>
                    <th scope="col">CPF</th>
                    <th scope="col">DDI</th>
                    <th scope="col">Telefone</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr key={this.props.dadosPagamento.cpfComprador}>
                    <td>{this.props.dadosPagamento.nomeComprador}</td>
                    <td>{this.props.dadosPagamento.cpfComprador}</td>
                    <td>{this.formatarDDi(this.props.dadosPagamento.ddiComprador)}</td>
                    <td>{this.props.dadosPagamento.telefoneComprador}</td>
                  </tr>
                  </tbody>
                  <tfoot>
                  <td colSpan={4} className='text-center'>
                    <button type="button" className="btn btn-excluir"
                            data-toggle="modal" style={{ color: 'red' }}
                            data-target="#modalCadastrarDadosComprador"
                            onClick={() => this.preencherValoresComprador(this.props.dadosPagamento)}>
                      <span>Editar</span>
                    </button>
                  </td>
                  </tfoot>
                </table>
              </div>
            </div>
            <ModalDadosComprador empresaSelecionada={this.props.empresaSelecionada}/>
          </React.Fragment>
      )
    }
    return (
        <div className="row mb-2">
          <div className="col-md-12">
            <div className="text-right">
              <button data-toggle="modal" data-target="#modalCadastrarDadosComprador"
                      className='btn btn-sm btn-laranja'>
                Adicionar dados
              </button>
            </div>
          </div>
          <ModalDadosComprador empresaSelecionada={this.props.empresaSelecionada}/>
        </div>
    )
  }
}

export function mapStateToProps (state) {
  return {
    dadosPagamento: state.dadosPagamento,
    empresaSelecionada: state.empresaSelecionada
  }
}

export default connect(mapStateToProps, {
  adicionarDadosComprador, changeFieldValue
})(reduxForm({
  form: 'formReserva',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate
})(DadosComprador));
